import { render, staticRenderFns } from "./salesteamlead_invoice.vue?vue&type=template&id=06c38d5b&scoped=true&"
import script from "./salesteamlead_invoice.vue?vue&type=script&lang=js&"
export * from "./salesteamlead_invoice.vue?vue&type=script&lang=js&"
import style0 from "./salesteamlead_invoice.vue?vue&type=style&index=0&id=06c38d5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c38d5b",
  null
  
)

export default component.exports